module.exports = __webpack_public_path__ + "img/8.31448c4b.webp";